function getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData) {
  if (!ajaxPage) ajaxPage = 0;
  if (!allAjaxData) allAjaxData = [];

  // We fetch up to 20 products per "page" of ajax calls, if there are more than 20
  // products in total we page through them (same batching as before).
  if (!numberProductPerAjaxCall || numberProductPerAjaxCall > 20) {
    numberProductPerAjaxCall = 20;
  }
  var fromIndex = numberProductPerAjaxCall * ajaxPage;
  var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
  var handles = [];
  for (var i = fromIndex; i < toIndex; i++) {
    handles.push(data[i].handle);
  }

  // Fix: the previous version built ONE request for the whole batch by joining
  // every handle with "+" (e.g. /collections/bulk/products/handle1+handle2+...).
  // Shopify's storefront routing only ever resolves a single literal product
  // handle per URL - any request for 2+ joined handles 404s (verified directly
  // against this store, on more than one collection). Combined with no `error`
  // handler on the ajax call below, that 404 was silently swallowed: `success`
  // never fired, so this whole chain - and ultimately the callback that tells
  // Boost's widget "rendering can proceed" - never ran, leaving the product
  // list stuck on its loading skeleton forever with no visible console error.
  //
  // Fetch each handle individually instead, via Shopify's always-available
  // /products/<handle>.js endpoint (single-handle routes always work, and the
  // response already has the price_min/price_max/variants shape getNewPrices
  // expects), in parallel, and tolerate individual failures so one bad lookup
  // can never block the whole page from rendering again.
  var fetches = handles.map(function(handle) {
    return new Promise(function(resolve) {
      jQ.ajax({
        type: "GET",
        url: "/products/" + handle + ".js",
        dataType: "json",
        success: function(productJson) {
          resolve(productJson);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error(
            'boost-pfs-multiple-currencies (' + templateName + '): failed to load /products/' + handle + '.js: ' +
            textStatus + (errorThrown ? ' - ' + errorThrown : '')
          );
          resolve(null); // don't let one failed lookup hang the whole batch
        }
      });
    });
  });

  Promise.all(fetches).then(function(results) {
    var pageProducts = results.filter(function(p) { return p; });
    onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, pageProducts, allAjaxData);
  });
}

function onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData) {
  // ajaxData is now already an array of parsed product objects (one per handle -
  // see the fetch fix above), so the old raw-string / HTML-comment-stripping /
  // JSON.parse step is no longer needed here.
  allAjaxData = allAjaxData.concat(ajaxData);

  // Compare how far this page reached (toIndex) against the full data length,
  // not the page's own fromIndex - avoids an extra, empty ajax call whenever
  // data.length is an exact multiple of numberProductPerAjaxCall (or lands one
  // short of it).
  var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
  if (toIndex < data.length) {
    ajaxPage++;
    getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData);
  } else {
    // After getting all products from all pages, call the callback function
    if (typeof callback == 'function') {
      callback(allAjaxData);
    }
  }
}

function getNewPrices(apiData, productsData) {
  // Read the current currency fresh on every call instead of relying on a
  // module-level value computed once at script load (which could go stale if
  // the shopper switches currency without a full page reload).
  var currency = boostPFSConfig.general.current_currency.toLowerCase();

  const result = { ...apiData, products: [...apiData.products] };

  productsData.forEach(function(product) {
    var apiProducts = result.products.filter(function(apiProduct) { return apiProduct.id === product.id; });
    if (apiProducts.length > 0) {
      for (var apiProduct of apiProducts) {
        apiProduct.compare_at_price_min = product.compare_at_price_min / 100;
        apiProduct.price_min = product.price_min / 100;
        apiProduct.price_max = product.price_max / 100;

        apiProduct['compare_at_price_min_' + currency] = product.compare_at_price_min / 100;
        apiProduct['price_min_' + currency] = product.price_min / 100;
        apiProduct['price_max_' + currency] = product.price_max / 100;

        for (var variant of product.variants) {
          var vidx = apiProduct.variants.findIndex(v => v.id === variant.id);
          if (vidx === -1) continue;

          apiProduct.variants[vidx].price = variant.price / 100;
          apiProduct.variants[vidx].compare_at_price = variant.compare_at_price / 100;
        }
      }
    }
  });

  return result;
}

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function(result, callbackFilterApi) {
    if (!result.products || result.products.length === 0) {
      callbackFilterApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-multiple-currencies", function(productsData) {
      callbackFilterApi(getNewPrices(result, productsData));
    });
  };
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    if (!result.products || result.products.length === 0) {
      callbackInstantSearchApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-multiple-currencies", function(productsData) {
      callbackInstantSearchApi(getNewPrices(result, productsData));
    });
  };
}